import React, { useState } from 'react';
// import { Form, Button, Radio, Input, Select } from 'antd';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import styles from './styles.module.less';
// import Privacy from './Privacy';

export const faqs = [
  {
    id: 1,
    question: 'How can I register at Elite Samskruti Website?',
    answer:
      "Registration to our site is completely free of cost. The user needs a working mobile number to register and receive a OTP for each login. Simply get on to the welcome page (linked text - open in new tab), Select the profile type and click on register now button. You will be directed to the personal details page. Fill the bride/groom's details and agree to the Privacy Policy and T&Cs to get started. Click on the lets begin button and you will be directed to the login page."
  },
  {
    id: 2,
    question: 'What are the benefits of registering on this Matrimonial site?',
    answer: [
      'Our website provides for an AI driven Smart-Match feature which allows its members to find a more accurate match with lesser impediment.',
      'Users can send and receive requests to start an interaction with other members.',
      'Horoscope details can be found by referring to a members birth details as provided by the individual.',
      'We give our members the capability to download multiple profiles of suitable matches according to their subscription plan limit.',
      'Members get notified upon their profile being liked by another user of the service.',
      'Users can have a conversation with our ChatBot in case of they face a hindrance or have general queries regarding the service.'
    ]
  },
  {
    id: 3,
    question: 'Can I change my mobile number after registration?',
    answer:
      'Yes, the user can change their contact details in the account information segment under the manage settings option (to be found in the profile ID dropdown).'
  },
  {
    id: 4,
    question: 'Can I change my Email ID after registration?',
    answer:
      'Yes, the user can change their contact details in the account information segment under the manage settings option (to be found in the profile ID dropdown).'
  },
  {
    id: 5,
    question: 'How much do I have to pay to use the service?',
    answer:
      'The subscription plans and their prices can be viewed in through the Membership link in the footer of our website.'
  },
  {
    id: 6,
    question: 'How do I log in after I have completed my initial registration?',
    answer:
      "User can directly use the login page or get redirected through the welcome page. Click on 'Already a member?' under the Register Now button in the welcome page."
  },
  {
    id: 7,
    question: 'Where do I need to submit my photograph?',
    answer:
      'The user gets to upload their profile photograph in the About Me Segment of the profile creation. The profile photo is a mandatory upload. Any other picture of the user, either self or with friends and family, can be uploaded but is not a mandatory requirement.'
  },
  {
    id: 8,
    question:
      'How do I contact another member/user of the Elite Samskruti Matrimony Site?',
    answer:
      'The user can send a request to any other member whose profile they are interested in. Only upon the acceptance of the user request any further conversation can take place and contact details of the member would be shared.'
  },
  {
    id: 9,
    question: 'When will my profile be searchable to another member/user?',
    answer:
      'Once the user enters all of their personal details in profile completion (all mandatory fields need to be filled) and purchases a membership plan, their profile would be available for search by the other members.'
  },
  {
    id: 10,
    question: 'How do I optimize my search to find the perfect match?',
    answer: [
      'Any user would need to ensure the following for optimizing their search:',
      'Fill in every mandatory field during account creation.',
      'Provide an accurate description of self for better functional search [specially when using the Elite subscriptions offered].',
      'Provide accurate details for desired partner down for efficient search processing.',
      'Upload a good (high resolution) image for their profile photo as well.'
    ]
  },
  {
    id: 11,
    question: 'Can I upgrade my membership plan? How much will it cost me?',
    answer: [
      'Yes, a membership plan can be upgraded. One can upgrade from a:',
      '- 3 months subscription plan to a 6months/12 months subscription plan',
      '- 6 months subscription plan to a 12 months subscription plan',
      '- Specialized to Elite Subcategory upgrade for each duration.',
      'During your membership upgrade your previous payment would be considered and you only need to pay the deficit amount to upgrade to your new plan.'
    ]
  },
  {
    id: 12,
    question: 'What are the modes of payment available to a user?',
    answer: [
      'We currently offer 5 modes of online payment for our users:',
      '1) Any UPI (Unified Payments interface) App identified by RBI',
      '2) Debit/Credit Cards [Mastercard, Visa, Rupay]',
      '3) Netbanking through Indian Bank Account holders',
      '4) E-Wallets [Mobikwik, Airtel Payment Bank, Ola Money, JioMoney and Freecharge]',
      '5) Pay Later services [LazyPay, ICICI, FlexiPay, ePayLater, Kotak Mahindra Bank, Amazon Pay Later and RazorpayXPostpaid]'
    ]
  },
  {
    id: 13,
    question:
      'Can I cancel my subscription? Will I get refunded on my payment?',
    answer:
      'No, the user will not be able to receive any refund for deactivating/deleting the account.'
  },
  {
    id: 14,
    question:
      'Can I delete my profile from the website? Will my details be available to anyone after that?',
    answer:
      'Yes, the user can delete their account through the account settings under manage settings option.'
  }
];

const FAQs = () => {
  const [openSections, setOpenSections] = useState({
    account: true
  });

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const navigateToDashboard = () => {
    window.location.href = '/welcome';
  };

  const renderAnswer = (answer) => {
    if (Array.isArray(answer)) {
      return (
        <div>
          {answer.map((point, index) => (
            <div key={index} className={styles.accountPoint}>
              {point}
            </div>
          ))}
        </div>
      );
    }
    return answer;
  };

  return (
    <div className={styles.container}>
      <button className={styles.back} onClick={navigateToDashboard}>
        Back
      </button>
      <div className={styles.outerBox}>
        <div className={styles.leftBox}>
          <h1 className={styles.leftHeader}>FAQ&apos;s</h1>
        </div>

        <div className={styles.rightBox}>
          <div className={styles.rightBoxInner}>
            {faqs.map(({ id, question, answer }) => (
              <div key={id}>
                <div
                  className={`${styles.accountHeader} ${
                    openSections[id] ? styles.active : ''
                  }`}
                  onClick={() => toggleSection(id)}
                >
                  <span>{question}</span>
                  {openSections[id] ? (
                    <FaChevronUp className={styles.accountIcon} />
                  ) : (
                    <FaChevronDown className={styles.accountIcon} />
                  )}
                </div>
                {openSections[id] && (
                  <div className={styles.accountContent}>
                    <div className={styles.accountRow}>
                      {renderAnswer(answer)}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQs;
